import { LAST_STEP_KEY } from '@src/features/common-application/constants';

const DEFAULT_STEP_PATH = 'account-type';

/**
 * Resolve the wizard step to enter for an application.
 *
 * Returns the last step the user was on, falling back to the first step when
 * there is no saved step or localStorage is unavailable (private browsing,
 * blocked site data). An unknown or ineligible step is normalized by
 * step-router, so no validation is needed here.
 */
export function getResumeStepPath(uuid: string | undefined): string {
  if (!uuid) {
    return DEFAULT_STEP_PATH;
  }

  try {
    return localStorage.getItem(`${LAST_STEP_KEY}${uuid}`) ?? DEFAULT_STEP_PATH;
  } catch {
    return DEFAULT_STEP_PATH;
  }
}
